import React, { useEffect, useState } from 'react'
import styles from '../../modal.module.css'

import Chip from '@material-ui/core/Chip'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'

import useFilterStore from '../../../../Store/filterStore'

import customDeleteIconSvg from './images/square-xmark.svg'
import { useStyles } from './utils/materialUI'
import Tooltip from '@material-ui/core/Tooltip'
import infoIcon from '../images/circle-info-regular-full.svg'
import { makeStyles } from '@material-ui/core/styles'

const useTooltipStyles = makeStyles({
  tooltip: {
    display: 'inline-block',
    maxWidth: 500,
    width: 'auto',
    fontSize: '13px',
    padding: '8px',
    whiteSpace: 'normal',
    lineHeight: 1.4,
    textAlign: 'left',
    wordBreak: 'break-word'
  },
  arrow: {}
})

function PostalCode ({ setLocalFilters, setLocationChanged }) {
  const {
    allFilters: { postalCode: initialPostalCodes }
  } = useFilterStore()

  const customDeleteIcon = (
    <img
      src={customDeleteIconSvg}
      alt='delete'
      style={{ width: 11, height: 13 }}
    />
  )

  const classes = useStyles()
  const tooltipClasses = useTooltipStyles()
  const [selectedPostalCodes, setSelectedPostalCodes] = useState([])
  const [inputValue, setInputValue] = useState('')

  const commitSelection = newValue => {
    setLocationChanged(true)
    setSelectedPostalCodes(newValue)
    setLocalFilters(prevFilters => ({
      ...prevFilters,
      postalCode: newValue
    }))
  }

  useEffect(() => {
    setSelectedPostalCodes(initialPostalCodes)
  }, [initialPostalCodes])

  return (
    <div className={styles.inputColumn}>
      <div className={styles.sectionTitleWithIcon}>
        <span className={styles.labelLocation}>Postal code</span>
        <Tooltip
          title='Filter by the postal code of the property.'
          arrow
          placement='top'
          classes={{
            tooltip: tooltipClasses.tooltip,
            arrow: tooltipClasses.arrow
          }}
        >
          <img
            src={infoIcon}
            alt='Postal code info'
            width={14}
            height={14}
            className={styles.infoIcon}
          />
        </Tooltip>
      </div>

      <Autocomplete
        style={{ padding: '0px', fontSize: '12px' }}
        freeSolo
        multiple
        open={false}
        id='prevent_autofill'
        closeIcon={false}
        popupIcon={false}
        value={selectedPostalCodes}
        onChange={(_, newValue) => {
          commitSelection(newValue)
          setInputValue('')
        }}
        deleteicon={customDeleteIcon}
        options={[]}
        getOptionSelected={(option, value) => option === value}
        getOptionLabel={option => option}
        inputValue={inputValue}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === 'input') {
            setInputValue(newInputValue)
          }
        }}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip
              label={option}
              {...getTagProps({ index })}
              deleteIcon={customDeleteIcon}
            />
          ))
        }
        classes={{ option: classes.option }}
        renderInput={params => (
          <TextField
            id='prevent_autofill'
            autoComplete='off'
            style={{ padding: '0px' }}
            placeholder='Text'
            variant='outlined'
            {...params}
            onBlur={() => {
              const trimmed = inputValue.trim()
              if (trimmed && !selectedPostalCodes.includes(trimmed)) {
                commitSelection([...selectedPostalCodes, trimmed])
              }
              setInputValue('')
            }}
            InputProps={{
              ...params.InputProps,
              classes: {
                root: classes.inputRoot,
                focused: classes.focused,
                notchedOutline: classes.notchedOutline
              }
            }}
          />
        )}
      />
    </div>
  )
}

export default PostalCode
